import React, {useCallback} from 'react';
import {Button, ButtonProps} from 'primereact/button';
import isFunction from 'lodash/isFunction';
import Analytics from '../../utils/Analytics';
import {SegmentEventTypes} from '../../data/tracking';
import {WrappedButtonType} from './WrappedButtonType.enum';

export {WrappedButtonType};

type WrappedButtonProps = ButtonProps & {
	className?: string;
	buttonType?: (typeof WrappedButtonType)[keyof typeof WrappedButtonType];
	additionalIconClassName?: string;
	segmentvalue?: string;
	iconPos?: ButtonProps["iconPos"],
	dataqa?: string
}

/**
 * WrappedButton is a wrapper around the PrimeReact Button component.
 * It adds analytics tracking and adds a convenient way to add an icon.
 */
export const WrappedButton: React.FC<WrappedButtonProps> = (props) => {
	const {
		className = '',
		// TODO: should really be 'data-qa'...
		dataqa: dataQa = 'ui-button-common',
		buttonType = WrappedButtonType.Primary,
		additionalIconClassName,
		onClick,
		segmentvalue,
		...rest
	} = props;

	const clickHandler = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>) => {
			Analytics.trackSegmentEvent({
				trackingData: {
					field_type: 'button',
					field_name_dataqa: `ui-button-${dataQa}`,
					field_value: segmentvalue,
				},
				eventType: SegmentEventTypes.UserInteraction,
			});

			if (isFunction(onClick)) {
				onClick(e);
			}
		},
		// TODO: enable react-hooks/exhaustive-deps in eslint config
		[onClick, dataQa, segmentvalue]);

	return (
		<div className={`common-ui-button ${className}`} data-qa={dataQa}>
			<Button
				{...rest}
				className={`ui-button-${buttonType}`}
				data-qa={`ui-button-${dataQa}`}
				onClick={clickHandler}
			>
				{additionalIconClassName && (
					<span className={`additional-button-icon ${additionalIconClassName}`}/>
				)}
			</Button>
		</div>
	);
};
